export enum LinkType {
  TermsAndConditions = "termsAndConditions",
  PrivacyPolicy = "privacyPolicy",
  ContactUs = "contactUs",
  HelpCenter = "helpCenter",
  Facebook = "facebook",
  LinkedIn = "linkedin",
  Twitter = "Twitter",
  Instagram = "instagram",
  Youtube = "youtube",
  AppStore = "appStore",
  GooglePlay = "googlePlay",
}

const links: { [key: string]: { [key: string]: string } } = {
  [LinkType.TermsAndConditions]: {
    ["es-ES"]: "https://info.cobee.io/hubfs/legal/Terminos_y_condiciones.pdf",
    ["pt-PT"]: "https://info.cobee.io/hubfs/legal/PT_T&C.pdf",
    ["es-MX"]: "https://info.cobee.io/hubfs/legal/MX_T&C.pdf",
    ["en-GB"]: "https://info.cobee.io/hubfs/legal/EN_T&C.pdf",
  },
  [LinkType.PrivacyPolicy]: {
    ["es-ES"]: "https://info.cobee.io/hubfs/legal/Privacidad_user.pdf",
    ["pt-PT"]: "https://info.cobee.io/hubfs/legal/Privacidad_user_PT.pdf",
    ["es-MX"]: "https://info.cobee.io/hubfs/legal/Privacidad_user_MX.pdf",
    ["en-GB"]: "https://info.cobee.io/hubfs/legal/Privacidad_user_ENG.pdf",
  },
  [LinkType.ContactUs]: {
    ["es-ES"]: "mailto:soporte@cobee.io",
    ["pt-PT"]: "https://www.pluxee.pt/contacto-cobee/",
    ["es-MX"]: "https://helpmx.cobee.io/hc/es-mx/requests/new",
    ["en-GB"]: "https://help.cobee.io/hc/en-gb/requests/new",
  },
  [LinkType.HelpCenter]: {
    ["es-ES"]: "https://help.cobee.io/hc/es-es",
    ["pt-PT"]: "https://help.cobee.io/hc/en-gb",
    ["es-MX"]: "https://helpmx.cobee.io/hc/es-mx",
    ["en-GB"]: "https://help.cobee.io/hc/en-gb",
  },
  [LinkType.Facebook]: {
    ["es-ES"]: "https://www.facebook.com/Cobee.Spain",
    ["pt-PT"]: "https://www.facebook.com/Cobee.Spain",
    ["es-MX"]: "https://www.facebook.com/cobee.mx",
    ["en-GB"]: "https://www.facebook.com/Cobee.Spain",
  },
  [LinkType.LinkedIn]: {
    ["es-ES"]: "https://www.linkedin.com/company/cobee-espana/",
    ["pt-PT"]: "https://www.linkedin.com/company/cobee-espana/",
    ["es-MX"]: "https://www.linkedin.com/company/cobee-espana/",
    ["en-GB"]: "https://www.linkedin.com/company/cobee-espana/",
  },
  [LinkType.Twitter]: {
    ["es-ES"]: "https://twitter.com/Cobee_es",
    ["pt-PT"]: "https://twitter.com/Cobee_es",
    ["es-MX"]: "https://twitter.com/Cobee_es",
    ["en-GB"]: "https://twitter.com/Cobee_es",
  },
  [LinkType.Instagram]: {
    ["es-ES"]: "https://www.instagram.com/cobee.io/",
    ["pt-PT"]: "https://www.instagram.com/cobee.io/?hl=es",
    ["es-MX"]: "https://www.instagram.com/cobee.mx/",
    ["en-GB"]: "https://www.instagram.com/cobee.io/",
  },
  [LinkType.Youtube]: {
    ["es-ES"]: "https://www.youtube.com/@cobee_",
    ["pt-PT"]: "https://www.youtube.com/@cobee_",
    ["es-MX"]: "https://www.youtube.com/@cobee_",
    ["en-GB"]: "https://www.youtube.com/@cobee_",
  },
  [LinkType.AppStore]: {
    ["es-ES"]: "https://apps.apple.com/es/app/cobee/id1453887676",
    ["pt-PT"]: "https://apps.apple.com/pt/app/cobee/id1453887676",
    ["es-MX"]: "https://apps.apple.com/es/app/cobee/id1453887676",
    ["en-GB"]: "https://apps.apple.com/en/app/cobee/id1453887676",
  },
  [LinkType.GooglePlay]: {
    ["es-ES"]:
      "https://play.google.com/store/apps/details?id=perkfinance.cobee&hl=es_419&pli=1",
    ["pt-PT"]:
      "https://play.google.com/store/apps/details?id=perkfinance.cobee&hl=pt_419&pli=1",
    ["es-MX"]:
      "https://play.google.com/store/apps/details?id=perkfinance.cobee&hl=es_419&pli=1",
    ["en-GB"]:
      "https://play.google.com/store/apps/details?id=perkfinance.cobee&hl=en_419&pli=1",
  },
};

export const getLink = ({
  linkType,
  language = "es-ES",
}: {
  linkType: LinkType;
  language: string;
}): string => {
  return links[linkType][language] || links[linkType]["es-ES"];
};
